// extracted by mini-css-extract-plugin
module.exports = {"faq":"_fb04636"};